export default {
    WITHIN_POLICY: 0,
    IN_POLICY_WITH_WARNING: 1,
    IN_POLICY_WITH_WARNING_AND_JUSTIFICATION: 2,
    OUT_OF_POLICY_BOOKING_ALLOWED: 3,
    OUT_OF_POLICY_BOOKING_ALLOWED_WITH_JUSTIFICATIONS: 4,
    OUT_OF_POLICY_BOOKING_PROHIBITED: 5,
};



// WEBPACK FOOTER //
// ./src/app/modules/flights/flight-recommendation/flight-fare/fare-out-of-policy-statuses.js